import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  textarea: {
    height: "100px",
    width: "100%",

    backgroundColor: "transparent",
    border: "1px solid #DCDCDC",
    borderRadius: 4,
    outline: "none",

    padding: "8px 12px",

    fontSize: "16px",
    color: "#0C0E29",
    fontFamily: "Lato, sans-serif",
    fontWeight: "normal",

    transition: "border-color 0.2s ease",

    "&:focus-visible": {
      borderColor: "#C3996B",
    },

    "&:hover": {
      cursor: "text",
    },

    "&:focus": {
      borderColor: "#C3996B",
    },

    "&:disabled": {
      backgroundColor: "#f5f5f5",
      cursor: "not-allowed",
    },
  },

  error: {
    borderColor: "#D84949 !important",
  },
});

const Textarea = ({
  value,
  onChange,
  placeholder,
  disabled,
  error,
  rows,
  ...props
}) => {
  const classes = useStyles();

  return (
    <textarea
      className={`${classes.textarea} ${error ? classes.error : ""}`}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      rows={rows || 4}
      {...props}
    />
  );
};

Textarea.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  rows: PropTypes.number,
};

Textarea.defaultProps = {
  value: "",
  onChange: () => {},
  placeholder: "",
  disabled: false,
  error: false,
  rows: 4,
};

export default Textarea;
